import _ from 'lodash';

const WIX_CODE_REFERENCE_BASE_URL = 'https://www.wix.com/code/reference/';

const HE_URL = 'https://static.parastorage.com/unpkg/he@1.2.0/he.js';

const GALLERY_CLICK_ACTIONS = {
    none: 'disabled',
    expand: 'zoomMode',
    link: 'goToLink'
};

const IMAGE_CLICK_ACTIONS = _.merge({magnified: 'zoomAndPanMode'}, GALLERY_CLICK_ACTIONS);

const IMAGE_FIT_MODE_MAP = {
    fixedWidth: 'fitWidth',
    fit: 'fit',
    fill: 'fill'
};

const IMAGE_FIT_MODE_INVERTED_MAP = {
    fitWidth: 'fixedWidth',
    fit: 'fit',
    fill: 'fill'
};

const GALLERY_ITEM_TYPES = {
    image: 'Image',
    video: 'Video',
    text: 'Text'
};

const EFFECTS = {
    CURRENT_EDITOR_EFFECT: {
        name: 'currentEditorEffect'
    },
    HIDE: {
        suffix: 'Out',
        noSuffixPresets: ['conceal'],
        deprecatedValues: [
            'ArcOut',
            'BounceOut',
            'CollapseOut',
            'Conceal',
            'FadeOut',
            'FlipOut',
            'FloatOut',
            'FlyOut',
            'FoldOut',
            'GlideOut',
            'PopOut',
            'SlideOut',
            'SpinOut',
            'TurnOut'
        ]
    },
    SHOW: {
        suffix: 'In',
        noSuffixPresets: ['reveal'],
        deprecatedValues: [
            'ArcIn',
            'BounceIn',
            'DropIn',
            'ExpandIn',
            'FadeIn',
            'FlipIn',
            'FloatIn',
            'FlyIn',
            'FoldIn',
            'GlideIn',
            'Reveal',
            'SlideIn',
            'SpinIn',
            'TurnIn'
        ]
    }
};

export {
    WIX_CODE_REFERENCE_BASE_URL,
    IMAGE_CLICK_ACTIONS,
    GALLERY_CLICK_ACTIONS,
    GALLERY_ITEM_TYPES,
    EFFECTS,
    IMAGE_FIT_MODE_MAP,
    IMAGE_FIT_MODE_INVERTED_MAP,
    HE_URL
};
